import { z } from 'zod';
export const agentIds = ['codex', 'claude', 'antigravity', 'grok', 'opencode', 'shell'];
export const agentIdSchema = z.enum(agentIds);
export const sessionStatusSchema = z.enum([
    'queued',
    'provisioning',
    'running',
    'stopped',
    'error',
    'archived',
]);
export const environmentSchema = z.object({
    id: z.string().min(1),
    name: z.string().trim().min(1).max(80),
    repositoryUrl: z.string().trim().url().or(z.literal('')),
    defaultBranch: z.string().trim().min(1).max(120).default('main'),
    setupCommand: z.string().max(10_000).default(''),
    dotenv: z.string().max(100_000).default(''),
    credentialProfileIds: z.array(z.string()).default([]),
    createdAt: z.unknown().optional(),
    updatedAt: z.unknown().optional(),
});
export const createEnvironmentSchema = environmentSchema
    .omit({ id: true, createdAt: true, updatedAt: true })
    .extend({ name: z.string().trim().min(1).max(80) });
export const createSessionSchema = z.object({
    title: z.string().trim().min(1).max(120),
    agent: agentIdSchema,
    model: z.string().trim().max(160).default(''),
    effort: z.string().trim().max(80).default(''),
    environmentId: z.string().trim().max(128).nullable().default(null),
});
export const sessionSchema = createSessionSchema.extend({
    id: z.string(),
    ownerUid: z.string(),
    status: sessionStatusSchema,
    archived: z.boolean().default(false),
    containerName: z.string().nullable().default(null),
    lastError: z.string().nullable().default(null),
    writerClientId: z.string().nullable().default(null),
    createdAt: z.unknown().optional(),
    updatedAt: z.unknown().optional(),
});
export const commandTypes = ['provision', 'start', 'stop', 'restart', 'archive', 'delete'];
export const commandTypeSchema = z.enum(commandTypes);
export const commandSchema = z.object({
    id: z.string(),
    ownerUid: z.string(),
    sessionId: z.string(),
    type: commandTypeSchema,
    status: z.enum(['queued', 'claimed', 'completed', 'failed']),
    workerId: z.string().nullable().default(null),
    attempts: z.number().int().nonnegative().default(0),
    error: z.string().nullable().default(null),
    createdAt: z.unknown().optional(),
    updatedAt: z.unknown().optional(),
});
export const terminalClientMessageSchema = z.discriminatedUnion('type', [
    z.object({ type: z.literal('input'), data: z.string().max(64 * 1024) }),
    z.object({
        type: z.literal('resize'),
        cols: z.number().int().min(20).max(500),
        rows: z.number().int().min(5).max(300),
    }),
    z.object({ type: z.literal('take-control') }),
    z.object({ type: z.literal('ping') }),
]);
export const terminalServerMessageSchema = z.discriminatedUnion('type', [
    z.object({ type: z.literal('output'), data: z.string() }),
    z.object({ type: z.literal('status'), status: z.string(), writable: z.boolean() }),
    z.object({ type: z.literal('error'), message: z.string() }),
    z.object({ type: z.literal('pong') }),
]);
export const agentCatalog = {
    codex: {
        label: 'Codex',
        accent: '#ff6b35',
        efforts: ['low', 'medium', 'high', 'xhigh'],
    },
    claude: {
        label: 'Claude Code',
        accent: '#d97757',
        efforts: ['low', 'medium', 'high', 'xhigh', 'max'],
    },
    antigravity: {
        label: 'Antigravity',
        accent: '#6d8cff',
        efforts: [],
    },
    grok: {
        label: 'Grok Build',
        accent: '#9da4b2',
        efforts: ['low', 'medium', 'high'],
    },
    opencode: {
        label: 'OpenCode',
        accent: '#8ac926',
        efforts: ['low', 'medium', 'high'],
    },
    shell: {
        label: 'Login shell',
        accent: '#22c55e',
        efforts: [],
    },
};
